<template>
  <div class="info">
    <el-form
      :model="userObject"
      ref="infoForm"
      label-width="120px"
      class="info-form"
    >
      <el-form-item> </el-form-item>
      <el-form-item label="用户头像" prop="avatarUrl">
        <upload-picture
          :imageUrl="userObject.avatarUrl"
          :width="'128px'"
          :height="'128px'"
          @getUrl="getImage"
        ></upload-picture>
      </el-form-item>
      <el-form-item label="用户ID" prop="id">
        <div>
          <el-input
            placeholder="请输入用户ID"
            v-model="userObject.id"
            style="width: 30%"
            disabled
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="用户昵称" prop="username">
        <el-input
          v-model="userObject.username"
          @input="getName"
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input
          v-model="userObject.phone"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="OPENID" prop="openId">
        <el-input
          v-model="userObject.openId"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否会员" prop="openId">
        <el-input
          v-model="userObject.isMemberL"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="可提现佣金" prop="commission">
        <el-input
          v-model="userObject.commission"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户推荐人ID" prop="referrerUserId">
        <el-input
          v-model="userObject.referrerUserId"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="加入时间" prop="joinTime">
        <el-input
          v-model="userObject.joinTime"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
      <el-form-item label="最近访问时间" prop="lastActiveTime">
        <el-input
          v-model="userObject.lastActiveTime"
          disabled
          style="width: 30%"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
  components: {
    uploadPicture
  },
  props: {
    userObject: Object
  },
  data () {
    return {
      name: 'cdd'
    }
  },
  created () {

  },
  methods: {
    getImage (e) {
      // console.log(e)
      this.$emit('getImage', e)
    },
    getName (e) {
      this.$emit('getName', e)
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
.info-form {
  font-weight: 400;
  font-size: 14px;
  color: #303033;
}
</style>

